import React from 'react';

//dropdown ZONAS => solo zonas de la ciudad seleccionada
const DetDetalleSelZo = props => {
  return (
    <option dato1={props.elemento.codigoZona} value={props.elemento.codigoZona}>{props.elemento.nombreZona}</option>
  )
};

const ListaZo = ({styles, handleLista2, list}) => {
// const Lista = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, i) => <DetDetalleSelZo styles={styles} elemento={elemento} key={i} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista2" onChange={handleLista2}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown ZONAS

export default ListaZo